import * as React from "react";
import "./IconButton.scss";

interface IconButtonProps {
  iconClassName: string;
  onClick: () => void;
}

const IconButton = (props: IconButtonProps) => {
  return (
    <button className="ic-button" onClick={props.onClick}>
      <i className={props.iconClassName} />
    </button>
  );
};

export default IconButton;
